module.exports = __webpack_public_path__ + "img/scanner.5269b5ef.png";